import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { DialogModalComponent } from '../../shared/components/dialog-modal/dialog-modal.component';
import { OrganizationsRoutingModule } from './organizations.routing';
import { OrganizationsGridComponent } from './pages/organizations-grid/organizations-grid.component';
import { NewOrganizationInviteComponent } from './pages/new-organization-invite/new-organization-invite.component';
import { NgxLoadingModule } from 'ngx-loading';
import { UsersByOrganizationsGridComponent } from './pages/users-by-organizations-grid/users-by-organizations-grid.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        OrganizationsRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        NgxLoadingModule,
        
    ],
    exports: [],
    declarations: [OrganizationsGridComponent, NewOrganizationInviteComponent, UsersByOrganizationsGridComponent],
    providers: [],
    entryComponents: [DialogModalComponent, NewOrganizationInviteComponent]
})
export class OrganizationsModule { }
